
<template>

</template>

<script>

export default {

  data(){
    return {

    }
  },

  watch: {
    '$screen.width': function(newData, oldData){
      if (newData <= this.$screen.height) this.$router.push({name: 'Org'});
    }
  }

}

</script>



// WEBPACK FOOTER //
// src/components/org/WebOrg.vue